/* tslint:disable:no-inferrable-types no-trailing-whitespace import-spacing typedef-whitespace align */

import { WindowType       } from './window';
import { DocumentMetadata } from './document.metadata';

/**
 *
 * @class JSONBrowserMetadata
 *
 * @brief meta data for JSON/text browser views.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2020
 *
 */
export class JSONBrowserMetadata extends DocumentMetadata {

  public key:  string  = '/';

  public mode: string  = 'json';

  public label: string = '';

  public jsonData: any = null;

  /** standard constructor */
  constructor(
    id:       string = '',
    title:    string = '',
    key:      string = '/',
    mode:     string = 'json',
    label:    string = '',
    icon:     string = '<i class="fas fa-edit"></i>',
    type: WindowType = WindowType.JSONBrowser,
    jsonData:    any = null
  ) {

    super(id, title, icon, type);

    this.key      = key;
    this.mode     = mode;
    this.label    = label;
    this.jsonData = jsonData;
  }

  /** convert this element to a simplified form that can be easily serialized */
  public node(init?: any) {

    return super.node({key: this.key, mode: this.mode});
  }

  /** initialize this element given the data in the simplified node object */
  public fromNode(node: any): void {

    super.fromNode(node);

    this.key  = node.key;
    this.mode = node.mode;
  }
}
